import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { user } from "src/components/login/login";
import { myAxios } from "src/components/common/functions";
import Form from "../form";
export const items = [
    {title: "nearMissFormBlock1", type: "display", content: <div className = "my-2 text-secondary font-weight-bold font-italic">
        <p>
            A Near Miss is an incident that took place without property damage or personal injury/illness, but were given a shift intime or position, damage or injury easily could have occurred.
        </p>
        <p>
            Un cuasi accidente es un incidente que tuvo lugar sin daños a la propiedad o lesiones / enfermedades personales, pero cuando se le dio un cambio en el tiempo o la posición, el daño o la lesión fácilmente podrían haber ocurrido.
        </p>
    </div>
    }, 
    {title: "Individual Reporting", type: "text", required: true, default: user.userName}, 
    {title: "Date", type: "date", required: true}, 
    {title: "Time", type: "time"}, 
    {title: "Location", type:"text", required: true}, 
    {title: "Project Name", type: "Select", options: [], required: true}, 
    {title: "What happened? How did you react to help/assist? Who was involved? When did you notice? Where did the details of the event occur?", type: "textarea", required: true},
    {title: "Approver Notes"}
];
//-------------------------------------------------------------------------------------------
export default function NearMissForm({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList
}){
    const [projects, setProjects] = useState([]);
    items[5].options = projects.map(project => ({
        value: project.projectName, 
        label: project.projectName
    }));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const resProjectNames = await myAxios("common/readProjectNames.php");
            if(!isMounted) return;
            setProjects(resProjectNames.data);
            
        }
        getData();
        return () => {isMounted = false;}
    },[]);
    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}
            
            items = {items}
        />
    )    
}